export const PREDICTIVE_SEARCH_TEMPLATE_SELECTOR = 'data-predictive-search-template';
export const CART_DRAWER_CONTENT_ID = 'cart-drawer-content';
export const PRODUCT_OPTIONS_PARAM = 'option_values';
export const BUTTON_LOADING_ATTR = 'loading';
export const ENTER_KEY_IDENTIFIER = 'Enter';
export const ESCAPE_KEY_IDENTIFIER = 'Escape';
export var GlobAttr;
(function (GlobAttr) {
    GlobAttr["HIDDEN"] = "hidden";
})(GlobAttr || (GlobAttr = {}));
export var ReqSection;
(function (ReqSection) {
    ReqSection["CART_DRAWER"] = "cart-drawer";
    ReqSection["PRODUCT_NOTIFIER"] = "notifier-product";
    ReqSection["CART"] = "cart";
    ReqSection["PREDICTIVE_SEARCH"] = "predictive-search";
})(ReqSection || (ReqSection = {}));
